import { render, staticRenderFns } from "./FooterContent.vue?vue&type=template&id=c35d6166&scoped=true&"
import script from "./FooterContent.vue?vue&type=script&lang=js&"
export * from "./FooterContent.vue?vue&type=script&lang=js&"
import style0 from "./FooterContent.vue?vue&type=style&index=0&id=c35d6166&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35d6166",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseLanguageSwitcher: require('/var/www/app/components/base/BaseLanguageSwitcher.vue').default})
